import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// ⚠️ importa los JSON con tus textos:
import es from "./locales/es.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector) // lee navigator.language o localStorage
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: "es", // si no detecta nada → español
    interpolation: { escapeValue: false },
  });

export default i18n;
